import React from 'react';
import PropTypes from 'prop-types';

import { mappedProductDefaultProps, mappedProductPropTypes } from 'ggApp/modules/product/constants';
import { product as productUrlBuilder } from 'ggApp/utils/urlBuilder/frontshop';
import ChipMapper from 'ggApp/shared/components/cards/Chips';

import { EnergyClass } from 'ggApp/shared/components/cards/ProductDetailsCard/EnergyLabels/styles';
import { energyRatingIcon } from 'ggApp/shared/components/cards/ProductDetailsCard/EnergyLabels/utils/energyLabelsMapper';

import {
    ChipsAndLabelBlock,
    PriceBlock,
    Description,
    FavoriteButton,
    Image,
    TextWrap,
    RootDiv,
    RootLink,
    NameContainer,
    Name,
    ImageContainer,
} from './verticalStyles';

const VerticalCard = ({
    className,
    product: {
        id,
        productName,
        slug,
        productCoreAttributes,
        selectedMinDuration,
        rentalPlan,
        oldPrice,
        price,
        chips,
        originalImage,
        energyClass,
    },
    style,
    onClick,
    onClickCallback,
    browserLink,
    preorderProduct,
    carousel,
    handpickedProduct,
    noCssOnImage = false,
}) => {
    const Container = slug ? RootLink : RootDiv;

    if (preorderProduct) {
        chips.push({ tk: preorderProduct.badge, type: 'promotional' });
    }
    const ImageTransform = [
        { effect: 'trim' },
        { quality: 'auto', fetchFormat: 'webp' },
        { width: '300', height: '300', crop: 'pad', background: 'white' },
    ];

    return (
        <Container
            className={className}
            style={{ ...style }}
            to={productUrlBuilder(slug, selectedMinDuration)}
            cardType="vertical"
            onClick={onClick}
            browserLink={browserLink}
            carousel={carousel}
        >
            <ImageContainer carousel={carousel} handpickedProduct={handpickedProduct}>
                <Image
                    className={className}
                    src={originalImage}
                    alt={productName}
                    transformations={ImageTransform}
                    width="300"
                    height="300"
                    noCss={noCssOnImage}
                    style={{ height: '100%' }}
                />
            </ImageContainer>
            <ChipsAndLabelBlock>
                {chips && chips.length > 0 ? (
                    <div>
                        <ChipMapper chips={chips} selectedRentalPlan={rentalPlan} />
                    </div>
                ) : null}
                {energyClass ? (
                    <EnergyClass icon={energyRatingIcon[energyClass]} width={29} height={16} />
                ) : null}
            </ChipsAndLabelBlock>
            <TextWrap>
                <NameContainer>
                    <Name>{productName}</Name>
                </NameContainer>
                {productCoreAttributes && <Description>{productCoreAttributes}</Description>}
                <PriceBlock
                    oldPrice={oldPrice}
                    price={price}
                    selectedMinDuration={selectedMinDuration}
                />
            </TextWrap>
            <FavoriteButton id={id} slug={slug} onClickCallback={onClickCallback} />
        </Container>
    );
};

VerticalCard.propTypes = {
    className: PropTypes.string,
    product: mappedProductPropTypes,
    onClick: PropTypes.func,
    onClickCallback: PropTypes.func,
    style: PropTypes.shape({}),
    browserLink: PropTypes.bool.isRequired,
};

VerticalCard.defaultProps = {
    className: '',
    product: mappedProductDefaultProps,
    style: null,
    onClick: () => undefined,
    onClickCallback: () => undefined,
};

export default VerticalCard;
